import {createSlice} from "@reduxjs/toolkit"
export const reportBuilderSlice = createSlice({
    name : "report builder",
    initialState :{
      "dimensionsVal":[ {
        dimensionTop: [
          { id: 1, name: "PFM" },
          { id: 2, name: "POP" },
          { id: 3, name: "Corporate" },      //corrected the sequence
          { id: 4, name: "Age Group"},
          { id: 5, name: "Tier Type"},
          { id: 6, name: "State" },
          { id: 7, name: "Category" },
      ],
      dimensionBottom: []}],
      "reportVal":[ {
        reportTop: [
          { id: 1, name: "AUM" },
          { id: 2, name: "TierI Total Net Contribution"},
          { id: 3, name: "TierII Total Net Contribution"},
          { id: 4, name: "PRAN Count"},
          { id: 5, name: "Total Contribution"},
          { id: 6, name: "Tier I AUM"},
          { id: 7, name: "Tier II AUM"},
      ],
      reportBottom: []}],
      "handelNavBarState" :"",
      "logicalFilter" : []

    },
    reducers:{
      setDimensionVal: (state, action) => {
        console.log("action from dimensionVal", action.payload);
        return {
          ...state,
          dimensionsVal: action.payload,
        };
      },
      setReportVal: (state, action) => {
        console.log("action from reportVal", action.payload);
        return {
          ...state,
          reportVal: action.payload,
        };
      },
      setHandelNavBarState :(state,action) =>{
       console.log("handelaction", action.payload);
       return{
        ...state,
        handelNavBarState : action.payload
       }
      },
      setLogicalFilter : (state,action) =>{
        console.log("action from logicalFilter", action.payload);
        return{
          ...state,
          logicalFilter :action.payload
        }
      }
    }
})
export const {setDimensionVal,setHandelNavBarState,setReportVal,setLogicalFilter} = reportBuilderSlice.actions